<script lang="ts" setup>
import type { PropType} from 'vue';
import { ref, shallowRef, watchEffect } from 'vue';
import { Common } from '@/common/Common';

const props = defineProps({
    icon: {
        type: String as PropType<string | null>,
        default: () => null
    },
    stroke: {
        type: Boolean,
        default: false
    },
    tooltip: {
        type: String,
        default: ''
    },
    spinning: {
        type: Boolean,
        default: false
    },
    size: {
        type: [Number, String],
        default: 20
    }
});

const chosenIcon = shallowRef<any>(null);

const customIcon = ref(false);

async function getCustomIcon(): Promise<any> {
    customIcon.value = true;
    return import(`../../assets/img/icons/${props.icon}.svg`);
}

watchEffect(async () => {
    if (props.icon == null || props.icon === '') return;

    // format the icons string for feather icons to avoid having to submit icon strings to the icon component as pascal case.
    const iconString = Common.toUpperPascalCase(props.icon.replace(/-./g, x => x[1].toUpperCase()));

    // load the icon (check if the icon name exists in the feather icon library first)
    chosenIcon.value = (await import('lucide-vue-next'))[iconString] ?? await getCustomIcon();
});

</script>
<template>
    <component
        :is="chosenIcon"
        v-if="icon != null && chosenIcon != null"
        v-tooltip="tooltip"
        :class="[stroke ? 'stroke' : 'fill', {'sy-custom-icon' : customIcon}, {'spinning' : spinning}] "
        :size="size"
    />
</template>
<style lang="scss" scoped>
    .spinning {
        animation: rotation 1s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }
</style>
